<template>
  <div class="groupBuying-container">
    <div class="titleBox">
      <span class="title">
        特惠拼团
        <!-- 装饰-左 -->
        <div class="decoration left">
          <div class="decoration-line"></div>
        </div>
        <!-- 装饰-右 -->
        <div class="decoration right">
          <div class="decoration-line"></div>
        </div>
      </span>
    </div>
    <div class="listBox">
      <div class="common" v-for="item of groupList" :key="item.id">
        <div class="left">
          <div class="title">{{ item.title }}</div>
          <div class="line"></div>
          <div class="description">{{ item.description }}</div>
        </div>
        <div class="right" @click="handleGroupList(item)">
          <img class="pt-pin" src="../../../assets/images/pt_pin.png" alt="">
          <img class="pt-home-right" src="../../../assets/images/pt_home_right.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      groupList: [
        {
          id: 1,
          title: '普通拼团',
          description: '2人起, 固定人数, 固定价格',
          type: 1 // 活动类型
        },
        {
          id: 2,
          title: '阶梯拼团',
          description: '参与人数越多, 价格逐级降低',
          type: 2 // 活动类型
        },
        {
          id: 3,
          title: '超级拼团',
          description: '人数较多, 极具吸引力的底价',
          type: 3 // 活动类型
        }
      ]
    }
  },
  created() {

  },
  methods: {
    // 跳转活动类型
    handleGroupList(item) {
      // 保存 type 到 Vuex
      this.$store.commit('pt/setGroupActivityType', item.type)
      // 清空拼团活动的状态，确保从首页进入时显示默认状态
      this.$store.commit('pt/setGroupActivityStatusOrder', null)
      this.$router.push({
        name: 'groupActivity'
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .groupBuying-container {
    // background: red;
    width: 1200px;
    margin: 20px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    .titleBox {
      width: 100%;
      text-align: center;
      position: relative;
      .title {
        color: #333333;
        font-size: 20px;
        position: relative;
        font-weight: 500;
        .decoration {
          position: absolute;
          width: 10px;
          height: 10px;
          background: #7CC4F0;
          border-radius: 50%;
          top: 50%;
          transform: translateY(-50%);
          .decoration-line {
            position: absolute;
            width: 6px;
            height: 6px;
            background: #8FCDF3;
            top: 50%;
            transform: translateY(-50%);
          }
          &.left {
            left: -20px;
            .decoration-line {
              border-radius: 6px 0 0 6px;
              left: -4px;
            }
          }
          &.right {
            right: -20px;
            .decoration-line {
              border-radius: 0 6px 6px 0;
              right: -4px;
            }
          }
        }
      }
      .moreBox {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 16px;
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        .lookMore {
          color: #666666;
        }
        /deep/ .el-icon-arrow-right {
          background: #C3C3C3;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          color: #FFFFFF;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }

    .listBox {
      width: 100%;
      display: flex;
      gap: 18px;
      background: #ffffff;
      height: 330px;
      align-items: center;
      justify-content:center ;
      flex-direction: column;
      .common {
        width: 1160px;
        height: 78px;
        background: #F4F4F4;
        border-radius: 10px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left {
          display: flex;
          justify-content: center;
          align-items: center;
          .title {
            color: #333333;
            font-size: 20px;
            font-weight: 500;
            margin: 0 56px;
          }
          .line {
            height: 30px;
            width: 1px;
            background: #cccccc;
            margin-right: 29px;
          }
          .description {
            color: #333333;
            font-size: 16px;
          }
        }
        .right {
          cursor: pointer;
          background: linear-gradient(to right, #6CB0DD, #3C90DE);
          height: 100%;
          width: 102px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
          .pt-pin {
            width: 30px;
            height: 30px;
          }
          .pt-home-right {
            width: 10px;
            height: 10px;
          }
        }
      }
    }
  }
</style>
